import instance from '@/api/business'
import { Company } from '@/types/Companies' 

export const fetchCompanies = async () => {
    const response = await instance.post<Company[]>('/companies/cockpit/companies')

    return response.data
}
 
